export const JSON_HTTP_HEADERS = {
  "Content-Type": "application/json",
  Accept: "application/json",
} as const;

export const FORM_HTTP_HEADERS = {
  "Content-Type": "application/x-www-form-urlencoded",
  Accept: "application/json",
} as const;

const OTP_HEADER = "X-OTP";

export function createBearerAuthHeaders(token: string) {
  return {
    Authorization: `Bearer ${token}`,
  };
}

/**
 * Whether a request is signed already. One that carries a token of its own
 * speaks for a project the session is not signed into, so the session token is
 * left out of it.
 */
export function carriesAuthHeader(headers: unknown): boolean {
  if (typeof headers !== "object" || headers === null) return false;

  return Boolean((headers as Record<string, unknown>).Authorization);
}

// The installation a request to the ecosystem is about, and the rights the
// visitor holds there. The ecosystem runs once and answers for every
// installation, so it is told which one to ask and asks it as the visitor.
const INSTALLATION_HEADER = "X-Installation";
const INSTALLATION_AUTHORIZATION_HEADER = "X-Installation-Authorization";

export function createInstallationHeaders(
  installationUuid: string,
  accessToken: string | null,
): Record<string, string> {
  return {
    [INSTALLATION_HEADER]: installationUuid,
    ...(accessToken
      ? {
          [INSTALLATION_AUTHORIZATION_HEADER]:
            createBearerAuthHeaders(accessToken).Authorization,
        }
      : {}),
  };
}

export function createOtpHeaders(otpCode: string | undefined) {
  return otpCode ? { [OTP_HEADER]: otpCode } : {};
}
